// extracted by mini-css-extract-plugin
module.exports = {"burger":"Burger_burger__2L5Hg","line":"Burger_line__34Erv","on":"Burger_on__27Gpo","top":"Burger_top__2omNO","middle":"Burger_middle__2jl2P","bottom":"Burger_bottom__gvP50"};